import { useRouter } from "next/navigation";
import { useAppDispatch } from "@/store/store";
import { setIsRedirecting } from "@/store/slices/globalSlice";

export const useRedirect = () => {
  const router = useRouter();

  const dispatch = useAppDispatch();

  return (url: string, scroll = false) => {
    router.push(url, { scroll });
    dispatch(setIsRedirecting(true));
  };
};
